import { SearchHistory } from "../classes/searchHistory";

export default class SearchHistoryService {
    //Instance
    static instance:SearchHistoryService;
    public static get Instance(){
        return SearchHistoryService.instance;
    }

    // Konstruktor und Member
    static searchHistory: SearchHistory;
    static hasSearchHistory: boolean;
    static searchHistoryIsSet: boolean;
    static sourceIsProduct: boolean;

    constructor(){}

    public static create(){
        SearchHistoryService.instance = new SearchHistoryService();
    }

    // Funktionen
    getNewSearchHistory(){
        return new SearchHistory({});
    }

    createSearchHistory(){
        if(!SearchHistoryService.searchHistory){
            SearchHistoryService.searchHistory = this.getNewSearchHistory();
        }
    }
    setSearchHistory(searchHistory:SearchHistory){
        if(!SearchHistoryService.searchHistory){
            this.createSearchHistory();
        }
        localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
        SearchHistoryService.searchHistory = searchHistory;
        this.setHasSearchHistory(searchHistory);
    }
    getSearchHistory():SearchHistory{
        const localStorageSearchHistory = localStorage.getItem("searchHistory");
        if(localStorageSearchHistory){
            SearchHistoryService.searchHistory = JSON.parse(localStorageSearchHistory) as SearchHistory;
        }else{
            this.createSearchHistory();
        }
        SearchHistoryService.searchHistory;
        return SearchHistoryService.searchHistory;
    }
    removeSearchHistory() {
        localStorage.removeItem("searchHistory");
        this.removeHasSearchHistory();
        this.removeHistoryMark();
    }

    checkSearchHistory() {
        const history = this.getSearchHistory();
        this.setHasSearchHistory(history)
        return SearchHistoryService.hasSearchHistory; 
    } 
    getHistoryType(){
        const history = this.getSearchHistory();
        return history.historyType;
    }

    setHasSearchHistory(history: SearchHistory) {
        const hasHistoy = (
            history &&
            (history.id !== null && history.id.toString().length>0)
        );
        const hasMark = this.checkHistoryMark();
        SearchHistoryService.hasSearchHistory = hasHistoy && !hasMark;
    }
    removeHasSearchHistory(){
        SearchHistoryService.hasSearchHistory = false;
    }
    setHistoryMark(){
        localStorage.setItem("backWithHistory", "true");
    }
    removeHistoryMark(){
        localStorage.removeItem("backWithHistory");
    }
    checkHistoryMark(){
        const mark = localStorage.getItem("backWithHistory");
        return mark && mark.length>0;
    }
    // callConversionUrl(pzn:string) {
    //     var conversionUrl = "https://kampagne.doc.green/aliud?" + pzn;
    //     return gtag_report_conversion(conversionUrl);
    // }
}